<template>
  <div class="purchase-schedule">
    <v-layout justify-space-between class="color--orange total-row">
      <v-flex class="d-flex align-center">
        이 매출의 입금 일정
      </v-flex>
    </v-layout>

    <template v-if="data && data.dailyData && data.dailyData.length > 0">
      <template v-for="daily in sortedDailyData">
        <v-layout 
          :key="daily.date"
          justify-space-between 
          class="subtitle detail-row color--nice-grey"
        >
          <v-flex class="d-flex align-start date">
            {{ $moment(daily.date).format('M월 D일') }}
          </v-flex>
          <v-flex class="amounts d-flex flex-column align-end">
            <template v-if="daily.card > 0">
              <div class="card-amount">
                카드 {{ $filters.commaFormat(daily.card) }}원
              </div>
            </template>
            <template v-if="daily.baemin > 0">
              <div class="delivery-amount">
                배민 {{ $filters.commaFormat(daily.baemin) }}원
              </div>
            </template>
            <template v-if="daily.yogiyo > 0">
              <div class="delivery-amount">
                요기요 {{ $filters.commaFormat(daily.yogiyo) }}원
              </div>
            </template>
            <template v-if="daily.coupang > 0">
              <div class="delivery-amount">
                쿠팡 {{ $filters.commaFormat(daily.coupang) }}원
              </div>
            </template>
          </v-flex>
        </v-layout>
      </template>
    </template>
    <template v-else>
      <div class="no-data">
        입금 예정 내역이 없습니다.
      </div>
    </template>

    <p class="notice">입금 예정일은 카드사, 배달플랫폼 별 평균 주기로 산정되었으므로 실제 입금일과 다를 수 있습니다.<br>
    선정산 이용시에는 매출 입금은 항상 익일이고, 위의 입급 예정일은 상환 일정이 됩니다.</p>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    // 날짜순으로 정렬된 데이터
    sortedDailyData() {
      if (!this.data?.dailyData) return []
      return [...this.data.dailyData].sort((a, b) => 
        new Date(a.date) - new Date(b.date)
      )
    }
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
.purchase-schedule {
  .total-row {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
  }

  .detail-row {
    margin: 12px 0;
    font-size: 15px;
    padding-left: 15px;

    .date {
      font-weight: 500;
      min-width: 90px;
    }

    .amounts {
      text-align: right;
      width: 100%;
      
      .card-amount, .delivery-amount {
        margin-bottom: 4px;
        white-space: nowrap;
      }

      .card-amount {
        color: #666666;
      }

      .delivery-amount {
        color: #666666;
      }
    }
  }

  img.icon {
    width: 22px;
    margin-right: 8px;
  }

  .debug-info {
    margin: 10px 0;
    padding: 10px;
    background-color: #f5f5f5;
    border-radius: 4px;
    font-family: monospace;
    font-size: 12px;
    white-space: pre-wrap;
  }

  .no-data {
    text-align: center;
    padding: 20px 0;
    color: #666;
    font-size: 14px;
  }

  .card-amount {
    color: #3c73dd;
  }

  .delivery-amount {
    color: #ffa500;
  }
}
</style> 